import script from "./DistrictClosureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DistrictClosureView.vue?vue&type=script&setup=true&lang=ts"

import "./DistrictClosureView.vue?vue&type=style&index=0&id=6e93be84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e93be84"]])

export default __exports__